import * as React from "react";
import * as style from "./Cruise.style";
import { IKImage } from "imagekitio-react";
import { classes } from "typestyle";
import { hooks } from "../../utility";
import { Link } from "react-router-dom";

interface ComponentProps {
  title: string;
  description: string;
  imageUrl?: string;
  imageAlt?: string;
  imageSrc?: string;
}

const Offer: React.FC<ComponentProps> = ({
  title,
  description,
  children,
  imageUrl,
  imageAlt,
  imageSrc,
}) => {
  const display = hooks.useDisplayContext();
  return (
    <div className={style.component}>
      <h1 className={style.title}>{title}</h1>
      <div className={style.description}>{description}</div>
      <div className={style.content}>
        {imageSrc ? (
          <img
            className={classes(style.section, style.image)}
            src={imageSrc}
            alt={imageAlt}
          />
        ) : (
          <IKImage
            className={classes(style.section, style.image)}
            path={imageUrl}
            alt={imageAlt}
          />
        )}
        <div className={style.section}>
          <div style={{ marginBottom: 30 }}>{children}</div>
          <a
            href="https://fareharbor.com/embeds/book/theoctolounge/?full-items=yes"
            rel="noreferrer"
            className={style.link}
          >
            <div className={style.bookButton}>Book Now</div>
          </a>
        </div>
      </div>
      <div className={style.content}>
        <div className={style.section}>
          <div className={style.subHeader}>What to bring:</div>
          <div className={style.details}>
            All cruises are BYOB. Bring your own booze.
          </div>
          <div className={style.details}>
            Each boat has a large cooler and ice on board so just bring your
            beverage of choice, sunscreen, towels, and clothing that you don't
            care about getting wet. We will be on a boat.
          </div>
          <Link to="/offers" className={style.link}>
            <div className={classes(style.bookButton, style.seeMore)}>
              See More Options
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

Offer.displayName = "Offer";
export { Offer };
